module.exports = __webpack_public_path__ + "static/img/beginner_class.452cbbd.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/beginner_class.png
// module id = XbuC
// module chunks = 1